import { CaseType, DropdownType } from '@safarilaw-webapp/feature/lpms/data-access';
import { IdName, SafariObject, SafariObjectId } from '@safarilaw-webapp/shared/common-objects-models';
import { Observable, of, switchMap } from 'rxjs';

export const NO_ITEMS_MESSAGE = 'No items configured';

export class CustomPicklist {
  id: SafariObjectId;
  name: string;
  isCustomizable: boolean;
  values?: IdName[]; // This will be mapped in the table component. If we don't put the values in the row then the search filter doesn't work.
}

export const picklistsToShow: CustomPicklist[] = [
  { id: DropdownType.CaseTypes, name: 'Case Types', isCustomizable: false },
  { id: DropdownType.CivilCaseSubtypes, name: null, isCustomizable: true },
  { id: DropdownType.CriminalCaseSubtypes, name: null, isCustomizable: true },
  { id: DropdownType.RegulatoryCaseSubtypes, name: null, isCustomizable: true },
  { id: DropdownType.OtherCaseSubtypes, name: null, isCustomizable: true },
  { id: DropdownType.LegalAuthorityTypes, name: 'Legal Authority Types', isCustomizable: true },
  { id: DropdownType.ResponseDocumentTypes, name: 'Response Document Types', isCustomizable: true },
  { id: DropdownType.NotifiedTeams, name: 'Notified Teams', isCustomizable: true }
];

export const dropdownToCaseTypeIdMap = {
  [DropdownType.CivilCaseSubtypes]: CaseType.Civil,
  [DropdownType.CriminalCaseSubtypes]: CaseType.Criminal,
  [DropdownType.RegulatoryCaseSubtypes]: CaseType.Regulatory,
  [DropdownType.OtherCaseSubtypes]: CaseType.Other
};

export const getCustomPicklistsObservable = (caseTypes$: Observable<IdName[]>): Observable<CustomPicklist[]> =>
  caseTypes$.pipe(
    switchMap(caseTypes =>
      of(
        picklistsToShow.map(picklist => {
          const caseType = dropdownToCaseTypeIdMap[picklist.id] ? caseTypes.find(ct => SafariObject.idEqual(ct.id, dropdownToCaseTypeIdMap[picklist.id])) : null;
          if (caseType) {
            return { id: picklist.id, name: `Case Subtypes - ${caseType.name}`, isCustomizable: picklist.isCustomizable };
          } else {
            return picklist;
          }
        })
      )
    )
  );
